module.exports = __webpack_public_path__ + "img/data-wwd-analyse.82df03ee.png";